import { render, staticRenderFns } from "./WaitingforCommercializingMasters.vue?vue&type=template&id=479172f6&"
import script from "./WaitingforCommercializingMasters.vue?vue&type=script&lang=js&"
export * from "./WaitingforCommercializingMasters.vue?vue&type=script&lang=js&"
import style0 from "./WaitingforCommercializingMasters.vue?vue&type=style&index=0&id=479172f6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports